import groupBy from 'lodash/groupBy';

export interface PermissionGroupOption {
  id: string;
  sub_level?: string | number | null;
  permissions: string[];
}

export interface PermissionGroup {
  id: string;
  name: string;
  level: number;
  permissions: string[];
  is_selectable: boolean;
  sub_level?: string | number | null;
  options?: PermissionGroupOption[];
}

/**
 * The permissions/groups API returns one row per sub-level (e.g. all vs
 * function-membership). Collapse those into a single group with options so
 * the UI lists each permission once.
 */
export function mapPermissionGroups(groups: PermissionGroup[]): PermissionGroup[] {
  const grouped = groupBy(groups, 'name');

  return Object.values(grouped).map((items) => {
    if (items.length === 1) return items[0];

    const [first] = items;

    return {
      ...first,
      options: items.map(({ id, sub_level, permissions }) => ({
        id,
        sub_level,
        permissions,
      })),
    };
  });
}
